'use client';
import useUser from '@/hooks/useUser';
import { useAuth } from '@/providers/AuthProvider';
import SpinnerIcon from '@/icons/SpinnerIcon';
import { getFollowing } from '@/lib/firebase/getFollowing';
import { TitleSection } from '@/ui/Title/Index';
import { cn } from '@pulsex/utils';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';

export default function FollowingPage() {
    const user = useUser();
    const { authReady } = useAuth();
    const [authors, setAuthors] = useState<any[]>([]);

    useEffect(() => {
        if (!authReady || !user) return;
        const fetchFollowing = async () => {
            try {
                const data = await getFollowing(user.uid);
                setAuthors(data);
            } catch (error) {
                console.error('Error fetching following:', error);
            }
        };
        fetchFollowing();
    }, [user, authReady]);

    if (!authReady) {
        return (
            <div className="container pt-8">
                <TitleSection title="قائمة الكتاب" as="h1" />
                <div className="w-full flex items-center justify-center">
                    <SpinnerIcon className="w-8 h-8" />
                </div>
            </div>
        );
    }

    if (!user) {
        return <div className="p-4 container mb-40">Please login to view your following.</div>;
    }

    return (
        <div className="container pt-8">
            <TitleSection title="قائمة الكتاب" as="h1" />
            <div className="flex items-center justify-center flex-wrap gap-x-10 max-[500px]:gap-x-3 gap-y-5 max-[500px]:gap-y-3">
                {authors.map((author: any, index: number) => {
                    return (
                        <div
                            className="flex flex-col space-y-2 relative lg:pt-2.5 lg:pb-2.5"
                            key={index}
                        >
                            <div
                                className={cn(
                                    'flex lg:items-end justify-center py-2',
                                    'max-md:flex-col max-md:space-y-3'
                                )}
                            >
                                <Link
                                    href={`/author/${author.id}`}
                                    className="relative px-4 pb-3 h-fit"
                                >
                                    <div className="block absolute bottom-0 right-0 z-[0] bg-lightgreyBackground h-1/2 w-full rounded-t-xl" />

                                    <div
                                        aria-label={author.name}
                                        className={cn(
                                            'relative overflow-hidden rounded-full p-1.5 bg-white z-[1]',
                                            'max-md:mx-auto max-[500px]:w-28 w-36 aspect-square'
                                        )}
                                    >
                                        <img
                                            src={
                                                author.image
                                                    ? author.image
                                                    : '/images/fallbackAuthor.png'
                                            }
                                            alt={`${author.name} profile image`}
                                            className="rounded-full"
                                        />
                                    </div>

                                    <div
                                        aria-label={author.name}
                                        className={cn(
                                            'cursor-pointer line-clamp-2 relative max-sm:my-3 text-center',
                                            'text-black max-md:mx-auto text-2xl'
                                        )}
                                    >
                                        {author.name}
                                    </div>
                                </Link>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
